import { Check } from "lucide-react";

const criteria = [
  "Have struggled with weight management",
  "Experience low energy or fatigue",
  "Want a clinician-guided approach",
  "Are focused on long-term health",
];

const WhoThisIsForSection = () => {
  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-sm font-semibold uppercase tracking-widest text-champagne mb-3">
            Is This Right For You?
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-foreground mb-6">
            Who This Is For
          </h2>
          <p className="text-muted-foreground mb-8">
            This program is designed for individuals who:
          </p>
          <ul className="space-y-4 text-left max-w-md mx-auto">
            {criteria.map((item) => (
              <li key={item} className="flex items-center gap-3 text-foreground">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                  <Check size={14} className="text-primary" />
                </div>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WhoThisIsForSection;
